import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-8 pb-12 px-6 overflow-hidden bg-gradient-to-b from-white to-cream" data-id="element-139">
      <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-rose-light/30 rounded-full blur-3xl pointer-events-none" data-id="element-140" />
      <div className="absolute top-[20%] right-[-10%] w-72 h-72 bg-gold-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-141" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center gap-1 mb-6" data-id="element-143">
          <div className="flex gap-1 text-gold-dark" data-id="element-144">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-145" />)}
          </div>
          <span className="text-xs md:text-sm font-medium text-dark/70 uppercase tracking-wider" data-id="element-146">
            Más de 1.200 tejedoras felices
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-3xl md:text-5xl lg:text-6xl font-bold text-dark mb-2 leading-[1.1]" data-id="element-147">
          ACCEDÉ A MÁS DE{' '}
          <span className="text-rose-deep italic font-serif font-normal" data-id="element-148">
            4.000
          </span>{' '}
          PATRONES PREMIUM
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-xl md:text-2xl lg:text-3xl font-serif text-gold-dark mb-4 leading-tight" data-id="element-149">
          Y CREÁ PIEZAS INCREÍBLES PARA USAR, REGALAR O VENDER
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: [0, -10, 0]
      }} transition={{
        opacity: {
          duration: 0.8,
          ease: 'easeOut'
        },
        y: {
          duration: 5,
          ease: 'easeInOut',
          repeat: Infinity
        }
      }} className="relative w-64 sm:w-80 md:w-96 my-6 drop-shadow-2xl" data-id="element-150">
          <img src="https://cdn.magicpatterns.com/uploads/gegQ7M7syGraCSucRMYf8Z/ChatGPT_Image_5_jun_2026,_00_01_24.png" alt="La Biblia del Crochet — La colección definitiva con más de 4.000 patrones" className="w-full h-auto object-contain" data-id="element-151" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-md md:text-lg text-dark/80 mb-6 max-w-2xl font-medium" data-id="element-152">
          Patrones organizados y listos para usar para que encuentres
          exactamente qué tejer en minutos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="flex flex-col sm:flex-row flex-wrap justify-center gap-y-2 gap-x-6 mb-8 text-sm md:text-base text-dark/80 font-semibold" data-id="element-153">
          {['Acceso inmediato', 'Más de 4.000 patrones', 'PDF listos para usar', 'Ideal para crear o vender'].map((benefit, i) => <div key={i} className="flex items-center gap-2" data-id="element-154">
              <div className="bg-gold/20 p-1 rounded-full" data-id="element-155">
                <Check className="w-4 h-4 text-gold-dark" data-id="element-156" />
              </div>
              <span data-id="element-157">{benefit}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="w-full" data-id="element-158">
          <CTAButton size="large" data-id="element-159" />
        </motion.div>
      </div>
    </section>;
}